// import React from "react";
import React from 'react';


const KevinFransPostCardWithSeparateCSS = () => {
  return (
    <div className="kevn_frans-post-feed">
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">19 Dec 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
                <a
                  className="kevn_frans-post-card-content-link"
                  href="https://kvfrans.com/small-research-tanh-activations-with-ddpg/"
                >
                  Small-Research: Tanh Activations with DDPG
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">19 Dec 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
                <a
                  className="kevn_frans-post-card-content-link"
                  href="https://kvfrans.com/small-research-policy-extraction-in-on-iql/"
                >
                  Small-Research: Policy Extraction in IQL
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">8 Sep 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
                <a
                  className="kevn_frans-post-card-content-link"
                  href="https://kvfrans.com/successor-representations-explained/"
                >
                  Successor Representations Explained
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">1 Aug 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/deriving-the-kl/">
                Deriving the KL divergence loss in variational autoencoders
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">15 May 2022</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/notes-on-aloe/">
                For AGI, we need better tasks. For better tasks, we need open-endedness. (ALOE 2022 Notes)
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">6 Dec 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/kvfrans-thoughts-nov-15/">
                A Mathematical Definition of Interestingness
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">12 Nov 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/causal-language-model/">
                To extract information from language models, optimize for causal response
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">2 Nov 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/thoughts-oct-29/">
                Data digesters, ML^2, Interestingness
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">28 Jun 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/clipdraw-exploring-text-to-drawing-synthesis/">
                CLIPDraw: Exploring Text-to-Drawing Synthesis
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
     
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">28 Jun 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/clipdraw-exploring-text-to-drawing-synthesis/">
                CLIPDraw: Exploring Text-to-Drawing Synthesis
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">3 Apr 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/stampca-conditional-neural-cellular-automata/">
                StampCA: Growing Emoji with Conditional Neural Cellular Automata
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">2 Dec 2020</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/quality-diversity-evolving-ocean-creatures/">
                Quality Diversity: Evolving Ocean Creatures
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">3 Apr 2021</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/open-endedness-3/">
                Open-Endedness 3: Multicell World
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">22 Oct 2020</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/open-endedness-2-bitwise-chemicals/">
                Open-Endedness 2: Bitwise Chemicals
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">15 Oct 2020</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/open-endedness/">
                Open-Endedness 1: Cellworld
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">27 Nov 2019</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/omakase-5-bullet-dance/">
                Omakase 5: Bullet Dance
              </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">21 Jul 2019</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/omakase-1-ropeman/">
                  Omakase 1: Ropeman
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">8 Apr 2019</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/linking-c-and-python-with-boost-anaconda/">
                  Linking C++ and Python with Boost (Anaconda)
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">12 Jul 2018</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a className="post-card-content-link" href="https://kvfrans.com/rain-project-the-story-of-building-a-touhou-fangame/">
                  RAIN Project: Evolution of the Game Development Dream
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">26 Oct 2017</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a
                  className="post-card-content-link"
                  href="https://openai.com/research/learning-a-hierarchy"
                >
                  [Link] Learning a Hierarchy
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header">
            <span>
              <time dateTime="2023-12-19">28 Feb 2017</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
              <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/coloring-and-shading-line-art-automatically-through-conditional-gans/"
                >
                  Deepcolor: Automatic Coloring and Shading of Manga-Style Lineart
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>




    </div>
  );
};
export default KevinFransPostCardWithSeparateCSS;